import ListboxPresentation from 'components/Listbox/ListboxPresentation'

export default {
  Presentation: ListboxPresentation,
}
